import { CompanyLocationUpdateDto } from 'src/Libs/company-settings/dto/company-location-update.dto'
import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { ApiResult } from 'src/Libs/api'

/**
 * Using the company/.../location api-endpoint to send some updates for a companies location
 *
 * @param companyId
 * @param resource
 * @param authFetch
 */
export const updateCompanyLocation = async (
  companyId: number,
  resource: CompanyLocationUpdateDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void>> => {
  return authFetch({
    method: 'PUT',
    payload: resource,
    path: `users/companies/${companyId}/location`,
  })
    .then(response => {
      if (response.status !== StatusCodes.NO_CONTENT) {
        return new ApiResult(null, true)
      }
      return new ApiResult(null, false)
    })
    .catch(() => {
      return new ApiResult(null, true)
    })
}
